import { render, staticRenderFns } from "./ProductoForm.vue?vue&type=template&id=d5a0914a&scoped=true&"
import script from "./ProductoForm.vue?vue&type=script&lang=js&"
export * from "./ProductoForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductoForm.vue?vue&type=style&index=0&id=d5a0914a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a0914a",
  null
  
)

export default component.exports